/** Pending microphone teardown survives account/provider replacement in this
 * browser document. UI idle is not evidence that a late getUserMedia or SDK
 * start has finished. Every new capture/start waits for earlier releases. */
const pending = new Set<Promise<void>>();
export function trackMicrophoneRelease(release: Promise<void>): Promise<void> {
  pending.add(release);
  // A failed teardown stays blocked until the document is replaced; failure
  // is not proof that the microphone became available.
  void release.then(() => pending.delete(release), () => {});
  return release;
}
export function waitForMicrophoneRelease(): Promise<void> {
  // Snapshot: a cancelled acquisition must never wait on its own teardown.
  return Promise.all([...pending]).then(() => {});
}
